export default __webpack_public_path__ + "static/media/portfolio-lg-2.9809d76f.webp";